<template>
    <div :id="defaultContainerId" class="nrp-tag" :class="custom">
        <span :id="tooltipId" class="nrpTooltip">{{title}}</span>
        <b-tooltip :target="tooltipId" :container="containerId" triggers="hover" :placement="direction"
        :custom-class="customTag" :boundary="'window'" :fallback-placement="[direction]">
            <div v-html="description"></div>
        </b-tooltip>
    </div>
    
</template>

<script>
import nrpConfig from '@/utilities/nrpConfig'
export default {
    name: "NrpTag",
    props: {
        isNrp: {
            type: Boolean
        },
        isFortyEightHoursNrpCruise: {
            type: Boolean
        },
        index: {
            type: String
        },
        direction: {
            type: String,
            default() {
                return 'bottom'
            }
        },
        customClasses: {
            type: Array,
            default() {
                return []
            }
        },
        targetContainer: {
            type: String
        },
        showRow: {
            type: Boolean,
            default: false,
        },
    },
    
    computed: {
        custom () {
            let customClass = {}
            if (this.customClasses.length > 0) {
                this.customClasses.forEach((custom) => {
                    customClass[custom] = true
                })
            }
            return customClass
        },
        customTag () {
            let customClass = []
            if (this.isFortyEightHoursNrpCruise) {
                customClass.push('fortyEightTag')
            }
            if (this.customClasses.length > 0) {
                customClass.push(this.customClasses[0])
            }
            if (customClass.length == 0) return ''
            customClass.push('tag')
            return customClass.join('_')
        },
        title () {
            if (this.isFortyEightHoursNrpCruise) {
                return nrpConfig.fortyEightHoursNrp.title
            } else if (this.isNrp) {
                return nrpConfig.nrp.title
            }
            return nrpConfig.rp.title
        },
        description () {
            // if (this.isFortyEightHoursNrpCruise) {
            //     return nrpConfig.fortyEightHoursNrp.description
            // } else if (this.isNrp) {
            //     return nrpConfig.nrp.description
            // }
            // return nrpConfig.rp.description
            // console.log(this.isNrp,'Nrptg isNrp')
            // console.log(this.showRow,'Nrptg showRow')
            if (this.isFortyEightHoursNrpCruise) {
                return nrpConfig.fortyEightHoursNrp.description
            } else if (this.isNrp) {
                // 收费退订
                if(this.showRow){
                    return this.$store.state.cruiseRow.nrpData.cancelPolicyNrpRow
                }else{
                    return this.$store.state.cruiseRow.nrpData.cancelPolicyNrp
                }
            }
            // 常规退订

            if(this.showRow){
                return this.$store.state.cruiseRow.nrpData.cancelPolicyRow
            }else{
                return this.$store.state.cruiseRow.nrpData.cancelPolicy
            }
        },
        tooltipId () {
            if (!this.index || this.index == '') {
                return 'nrpTag_tooltip_' + (new Date()).getTime() + Math.random(1000)
            }
            return 'nrpTag_tooltip_' +this.index
        },
        containerId () {
            if (this.targetContainer && this.targetContainer.length > 0) {
                return this.targetContainer
            }
            return this.defaultContainerId
        },
        defaultContainerId () {
            if (!this.index || this.index == '') {
                return 'nrpTag_container_' + (new Date()).getTime() + Math.random(1000)
            }
            return 'nrpTag_container_' +this.index
        }
    }
}
</script>

<style lang="less" scoped>
.nrp-tag {
    display: inline-block;
    vertical-align: middle;
    color: #337ab7;
    span.nrpTooltip {
        color: #337ab7;
        cursor: pointer;
    }
}
</style>

<style lang="less">
div.tooltip.b-tooltip {
    opacity: 1;
}
.nrp-tag {
    .arrow {
        position: absolute;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
    }
    .tooltip.bs-tooltip-right {
        padding: 0 5px;
        margin-left: 3px;
        .arrow {
            top: 50%;
            left: 0;
            margin-top: -5px;
            border-width: 5px 5px 5px 0;
            border-right-color: #fff;
        }
    }
    .tooltip-inner {
        // width: 400px;
    }
}

.stateroomDetailNrp {
    text-decoration: underline;
    .tooltip {
        width: 310px;
    }
}


.fortyEightHoursNrp {
    .tooltip {
        // transform: translate3d(721px, -100px, 0px) !important;
    }
}

.fortyEightHoursNrp .tooltip .tooltip-inner{
    width: 500px;
    max-width: 500px;
}

// .fortyEightTag_stateroomDetailNrp_tag.tooltip .tooltip-inner{
//     width: 700px;
//     max-width: 700px;
// }

/*收费常规*/
.cabinDetail-box + .cabinDetail-box {
    margin-top: 10px;
}

.cabinDetail-box {
    padding: 0 10px;
    background-color: #fff;
}

.cabinDetail-txt-bold {
    color: #333;
    font-weight: bold;
}

.cabinDetail-txt {
    padding-bottom: 13px;
    font-size: 12px;
    line-height: 20px;
    color: #666;
}

.blue {
    color: #4A90E2;
}

.cabinDetail-txt .cabinDetail-txt-bold {
    margin: 10px 0 0;
}
</style>

